import { render, staticRenderFns } from "./DisplayLogicLevel.vue?vue&type=template&id=4bf5c6f4"
import script from "./DisplayLogicLevel.vue?vue&type=script&lang=js"
export * from "./DisplayLogicLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports